//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectCurveList.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BinderGap",1,0],[1,"ConstraintFaceLower",0,"ScCollector",0],[1,"ConstraintFaceUpper",0,"ScCollector",0],[0,"Contact",1,0],[1,"DrawBeadLine",0,"SelectCurveList",0],[0,"Edit",1,0],[0,"EditType",1,0],[0,"FinalToolForce",1,0],[0,"FrictionCofficient",1,0],[0,"FrictionTypes",1,0],[0,"InitToolForce",1,0],[0,"KeepRegion",1,0],[0,"LoadingType",1,0],[0,"ProcessType",1,0],[0,"ProcessUdoEntity",1,"NXObject",0],[0,"ReferToolType",1,0],[0,"SteelAngle",1,0],[0,"SteelMotionDirection",1,"Direction",0],[0,"ToolPosition",1,0],[1,"ToolSelection",0,"ScCollector",0],[0,"ToolUdo",1,"NXObject",0],[0,"ToolsType",1,0],[1,"TrimmingLine",0,"SelectCurveList",0],[0,"TrimmingOption",1,0]],[[["processUdo","toolUdo","option"],"UpdateToolsGeoemtry",{},3,0],[[],"InitCalculateDrawingToolForce",{},0,0],[[],"CreateFacetForPreview",{},0,0],[[],"AddToolsGeoemtry",{},0,0],[[],"AddTrimmingLines",{},0,0],[[],"CalculateDistanceOfPadAndReferTool",{R_:{distance:''}},0,0]],[]];
SPLM.Tooling.FormingSimulationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FormingSimulationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FormingSimulationBuilder.ToolTypes = Object.freeze({
    "UpperPad" : "UpperPad", "LowPad" : "LowPad", "Steel" : "Steel", "Punch" : "Punch", "Die" : "Die", "Holder" : "Holder", "Pad" : "Pad", "Drawbead" : "Drawbead", "TrimmingLine" : "TrimmingLine", "Constriant" : "Constriant"});

SPLM.Tooling.FormingSimulationBuilder.LubeLevel = Object.freeze({
    "Clean" : "Clean", "Standard" : "Standard", "Special" : "Special", "UserDefine" : "UserDefine"});

SPLM.Tooling.FormingSimulationBuilder.ForceType = Object.freeze({
    "Spring" : "Spring", "Rigid" : "Rigid"});

SPLM.Tooling.FormingSimulationBuilder.ReferTool = Object.freeze({
    "Punch" : "Punch", "Die" : "Die", "Holder01" : "Holder01", "Holder02" : "Holder02", "Holder03" : "Holder03"});

SPLM.Tooling.FormingSimulationBuilder.ToolEdit = Object.freeze({
    "Delete" : "Delete", "Update" : "Update", "ReMesh" : "ReMesh", "None" : "None"});

SPLM.Tooling.FormingSimulationBuilder.TrimmingRegion = Object.freeze({
    "Keep" : "Keep", "Discarded" : "Discarded"});

SPLM.Tooling.FormingSimulationBuilder.TrimmingType = Object.freeze({
    "Tool" : "Tool", "Laser" : "Laser"});

export default SPLM;